import FormAddLpV2 from "../formAddv2";

const AddLiquidity = ({
  slippageTolerance,
  setOpenSlippage,
  poolDetail,
  contractAddress,
  binActive,
  setBinActive
}: any) => {
  return (
    <>
      <div className="block-header">
        <h1>Deposit Liquidity</h1>
        <figure
          onClick={() => {
            setOpenSlippage(true);
          }}
        >
          <img src="/assets/images/swap/settings.svg" alt="icon" />
        </figure>
      </div>
      <FormAddLpV2
        slippageTolerance={slippageTolerance}
        poolDetail={poolDetail}
        contractAddress={contractAddress}
        binActive={binActive}
        setBinActive={setBinActive}
      />
    </>
  );
};

export default AddLiquidity;
